import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/EmiForm.css";

function EmiDocuments() {
  const navigate = useNavigate();
  const [files, setFiles] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, files: selected } = e.target;
    setFiles(prev => ({ ...prev, [name]: selected[0] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const emi_id = localStorage.getItem("emi_id");
    if (!emi_id) {
      alert("Missing EMI ID. Please complete EMI form first.");
      return;
    }

    const required = ["aadhaar_front", "aadhaar_back", "pan_card", "passbook", "photo", "cheque"];
    for (let f of required) {
      if (!files[f]) return alert(`Please upload: ${f.replace(/_/g, " ")}`);
    }

    const formData = new FormData();
    formData.append("emi_id", emi_id);
    for (let key in files) {
      formData.append(key, files[key]);
    }

    setLoading(true);
    const res = await fetch("https://kolibusiness.com/backend/submit-documents.php", {
      method: "POST",
      body: formData
    });

    const result = await res.json();
    setLoading(false);

    if (result.success) {
      alert("✅ Documents uploaded successfully!");
      navigate("/emi-options");
    } else {
      alert("❌ Upload failed: " + result.message);
    }
  };

  return (
    <div className="emi-form-wrapper">
      <form onSubmit={handleSubmit} className="emi-form-box">
        <h2>📤 Upload Required Documents</h2>

        <label>Aadhaar Front *</label>
        <input type="file" name="aadhaar_front" accept="image/*" onChange={handleChange} />

        <label>Aadhaar Back *</label>
        <input type="file" name="aadhaar_back" accept="image/*" onChange={handleChange} />

        <label>PAN Card *</label>
        <input type="file" name="pan_card" accept="image/*" onChange={handleChange} />

        <label>Passbook *</label>
        <input type="file" name="passbook" accept="image/*" onChange={handleChange} />

        <label>Photo / Selfie *</label>
        <input type="file" name="photo" accept="image/*" onChange={handleChange} />

        <label>Cancelled Cheque *</label>
        <input type="file" name="cheque" accept="image/*" onChange={handleChange} />

        <label>Debit Card (Front)</label>
        <input type="file" name="debit_front" accept="image/*" onChange={handleChange} />

        <label>Debit Card (Back)</label>
        <input type="file" name="debit_back" accept="image/*" onChange={handleChange} />

        <button type="submit" disabled={loading}>
          {loading ? "Uploading..." : "Continue to EMI Options"}
        </button>
      </form>
    </div>
  );
}

export default EmiDocuments;
